import { AxiosResponse } from "axios";
import axiosClient from "../common/axios/axiosConfig";
import { chatDTO } from "../common/dtos/chatDTO";

const getChats = async (
  userCodu: number,
  senderCodu?: number
): Promise<chatDTO[]> => {

  if (localStorage.getItem(`${userCodu}.list-talks`)) {
    const cachedData = localStorage.getItem(`${userCodu}.list-talks`);
    if (cachedData) {
      return JSON.parse(cachedData);
    }
  }

  const response: AxiosResponse<chatDTO[]> = await axiosClient.get(
    "list-talks",
    {
      params: {
        user: userCodu,
      },
    }
  );

  if (senderCodu) {
    return response.data.map((chatItem) => {
      if (Number(chatItem.codu) === Number(senderCodu)) {
        return {
          ...chatItem,
          notif: true,
        };
      }
      return { ...chatItem, notif: false };
    });
  }

  localStorage.setItem(`${userCodu}.list-talks`, JSON.stringify(response.data));

  return response.data;
};

export default getChats;
